/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React, { useEffect, useRef } from "react";
import classNames from "classnames";
import BottomBoardCSS from "./BottomBoard.css";

const BottomBanner = ({ showBanner, config, Banner, setBoundingBox }) => {
  const bannerRef = useRef(null);

  useEffect(() => {
    if (bannerRef.current) {
      const rect = Array.from(bannerRef.current.childNodes)[0].getBoundingClientRect();
      setBoundingBox(rect);
    }
  }, [showBanner]);

  const viewClassNames = classNames(BottomBoardCSS.View, {
    [BottomBoardCSS.MountAnimation]: config.enableAnimation && showBanner,
    [BottomBoardCSS.UnmountAnimation]: config.enableAnimation && !showBanner
  });

  const Cmp = () => (
    <div data-testid="bottom-board-banner-view" className={viewClassNames} ref={bannerRef}>
      <Banner />
    </div>
  );

  const Container = () => (
    <div data-testid="bottom-board-banner-container" className={BottomBoardCSS.BannerContainer}>
      <Cmp />
    </div>
  );

  const shouldShow = showBanner && Banner;
  return shouldShow ? <Container /> : null;
};

export default BottomBanner;
